// utility/statusColors.js
export function getStatusColors(status) {
  let colors = {
    text: "white",
    chip: "white",
  };

  switch (status) {
    case "IN-PROGRESS":
      colors.text = "var(--color-primary-blue)";
      colors.chip = "var(--color-secondary-light-blue)";
      break;
    case "HOLD":
      colors.text = "var(--color-secondary-red)";
      colors.chip = "var(--color-secondary-light-red)";
      break;
    case "PENDING":
      colors.text = "var(--color-secondary-orange)";
      colors.chip = "var(--color-secondary-light-orange)";
      break;
    case "COMPLETED":
      colors.text = "var(--color-secondary-green)";
      colors.chip = "var(--color-secondary-light-green)";
      break;
    case "PLANNING":
      colors.text = "#808080";
      colors.chip = "#F5F5F5";
      break;
  }
  return colors;
}

export function getActiveStatusColors(status) {
  let colors = {
    text: "white",
    chip: "white",
  };

  switch (status) {
    case "ACTIVE":
      colors.text = "var(--color-secondary-green)";
      colors.chip = "var(--color-secondary-light-green)";
      break;
    default:
      colors.text = "var(--color-secondary-red)";
      colors.chip = "var(--color-secondary-light-red)";
      break;
  }
  return colors;
}